{
  "version": "0.2.0",
  "gitCommitHash": "07a593b4cfcf889c6babd1bc8eacdec33cd148c6",
  "gitCommitShortHash": "07a593b",
  "gitBranch": "HEAD",
  "gitTags": "",
  "clean": true
}